import React from 'react'
import SettingsMetaData from '../../../../Components/Hooks/useSettingsMetaData'

function Validity() {
  return (
    <SettingsMetaData propertyName={"validity_quotes"} viewPropertyName={"Validity"} />

  )
}

export default Validity